/** Chemins standard (scripts/sync-module-logos.mjs → public/assets/img). */
const MODULE_LOGO = "/assets/img/logo.png";
const MODULE_LOGO_SMALL = "/assets/img/logo-small.png";

export type PepLogoVariant = "header" | "footer" | "compact";

/** Logo ITaaS Suite + nom commercial (core/logos). */
export function PepLogo({ variant = "header" }: { variant?: PepLogoVariant }) {
  const imgSrc = variant === "compact" ? MODULE_LOGO_SMALL : MODULE_LOGO;
  const showName = variant === "header";

  return (
    <span className={`pep-brand-mark pep-brand-mark--${variant}`}>
      <img
        src={imgSrc}
        alt=""
        role="presentation"
        className="pep-brand-mark__img"
        decoding="async"
      />
      {showName ? (
        <span className="pep-brand-mark__name">ITaaS Suite</span>
      ) : (
        <span className="visually-hidden">ITaaS Suite</span>
      )}
    </span>
  );
}
